module.exports = __webpack_public_path__ + "img/arrow.fc54463a.svg";